import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '../../assets/styles/components/tab-header/tab-header.scss';
import { getSafe } from '@/helpers/global';
import RefreshIcon from '@/assets/images/icons/icon_refresh.png';
import LightRefreshIcon from '@/assets/images/icons/light/icon_refresh.png';
import EnlargeIcon from '@/assets/images/icons/light/icon_enlarge.png';
import CheckedIcon from '@/assets/images/icons/icon_select_hit.png';
import UnCheckIcon from '@/assets/images/icons/icon_select_normal.png';
import ExportIconDark from '@/assets/images/icons/light/export_icon_dark.png';
import ExportIconLight from '@/assets/images/icons/light/export_icon_light.png';
import { ORDER_FILTER_STATUS, TRANSACTION_TYPE, ACCOUNT_TYPE, STATEMENT_TYPE, PERIOD, CURRENCY} from '@/constants/filter-type';
import { DATE_PICKER_TYPE } from '@/constants/app';
import DatePickerCustom from '@/components/DatePicker/DatePickerCustom';
import Dropdown from '@/components/Dropdown/Dropdown';
import { openAAStockDisclaimerDialog ,openWatchListGroupDialog} from '@/actions/app/dialog.action'
import { writeFileFunctions ,Converter, keyDownFunctions,accessibilityFunctions } from '@/helpers/functions';
import BlockControl from '@/components/BlockControl/BlockControl';
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants';
import { Icons } from '@/configurations';

class TabHeader extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this)
    this.state = {
      mainTabs: [],
      subTabs: [],
      currentMainTab: {},
      currentSubTab: {},
      haveActions: false,
      selectedOrderFilterStatus: ORDER_FILTER_STATUS[0].value,
      selectedTransactionHistoryType: TRANSACTION_TYPE[0].value,
      minimumDate: {},
      fromDate: {},
      toDate: {},
      selectedAccountType: ACCOUNT_TYPE[0].value,
      selectedStatement: STATEMENT_TYPE[0].value,
      selectedPeriod: PERIOD[0].value,
      selectedFromCurrency: CURRENCY[0].value,
      selectedToCurrency: CURRENCY[0].value,
    }
  }
  render() {
    const { exportExecl, justifyContent, alignItems, enableScroll, language, customStyle, refresh, orderFilter, dateRangePicker, orderFilterDropdown, transactionHistoryFilter, style, marketFilter, accountDropDown, accountData, accountTypeFilter, statementTypeFilter, periodFilter, currencyRangePicker,AAStockDisclaimer, browser, theme } = this.props;
    const { mainTabs, subTabs, currentMainTab, currentSubTab, haveActions } = this.state;
    return (
      <div className='tab-header-container' style={style}>
        <div className={classnames('main-tab', subTabs.length > 0 && 'main-tab-has-children', enableScroll && 'scroll-horizontal')}
          style={{ justifyContent: justifyContent, alignItems: alignItems }}>
          {mainTabs.map(tab =>
            <div key={tab.id}
              style={customStyle}
              className={classnames('main-tab-item', getSafe(() => currentMainTab.id, -1) === tab.id && 'main-tab-item-active')}
              onClick={() => this.handleChangeMainTab(tab)}
              onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handleChangeMainTab(tab))}
              {...accessibilityFunctions.hasTabIndex()}
              title={getSafe(() => language[tab.title], tab.title)}>
              {getSafe(() => language[tab.title], tab.title)}
            </div>
          )}
          {haveActions && <div className='tab-header-action'>
            {dateRangePicker && this.renderDateRangePicker()}
            {AAStockDisclaimer && this.renderAAStockDisclaimer()}
            {orderFilter && this.renderOrderFilter()}
            {orderFilterDropdown && this.renderOrderFilterDropdown()}
            {transactionHistoryFilter && this.renderHistoryFilterDropdown()}
            {accountDropDown && this.renderAccountDropdown()}
            {marketFilter && this.renderMarketDropdown()}
            {accountTypeFilter && this.renderAccountTypeFilterDropdown()}
            {statementTypeFilter && this.renderStatementTypeFilterDropdown()}
            {periodFilter && this.renderPeriodFilterDropdown()}
            {currencyRangePicker && this.renderCurrencyDropdown()}
            {exportExecl && this.renderExportExeclButton()}
            {refresh &&
              <div className='action-item'>
                <img src={ (browser === 'ie' && theme==='light') ? LightRefreshIcon : (currentMainTab.title === 'chart'? EnlargeIcon:RefreshIcon) } alt={language.common_refresh} title={currentMainTab.title === 'chart' ? "": language.common_refresh} onClick={this.props.onRefresh} {...accessibilityFunctions.hasTabIndex()} onKeyDown={keyDownFunctions.handleEnterKeyDown(this.props.onRefresh)}/>
              </div>
            }
          </div>}
        </div>
        <div className='sub-tab'>
          {subTabs.map(tab =>
            <div key={tab.id}
              className={classnames('sub-tab-item', getSafe(() => currentSubTab.id, -1) === tab.id && 'sub-tab-item-active')}
              style={tab.style}
              onClick={() => this.handleChangeSubTab(tab)}
              onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handleChangeSubTab(tab))}
              {...accessibilityFunctions.hasTabIndex()}
              onContextMenu={(e) => this.handleContextMenu(e, tab)}
              title={getSafe(() => language[tab.title], tab.title)}>
              {getSafe(() => language[tab.title], tab.title)}
              {tab.icon}
            </div>
          )}
          {currentMainTab.title != 'common_market' && <div className="action-item">
            <label className="flex" onClick={()=>this.props.onClickColumnSetting(currentMainTab)}
                    onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.props.onClickColumnSetting(currentMainTab))}
                    {...accessibilityFunctions.hasTabIndex()}>
             { theme === 'light' ? <Icons.MultipleSelectionLight/> : <Icons.MultipleSelection/> }
              </label>
          </div>}
        </div>
      </div>
    )
  }

  handleSelectOrderType(key) {
    if (key) {
      this.setState({ selectedOrderFilterStatus: key.value });
      this.props.onSelectOrderFilter(key.value)
    }
  }

  handleSelectTransitionHistoryType(key) {
    this.setState({ selectedTransactionHistoryType: key.value });
    this.props.onSelectHistoryFilter(key.value)
  }

  handleSelectAccountTypeFilter(key){
    this.setState({ selectedAccountType: key.value });
    this.props.onSelectAccountTypeFilter(key.value)
  }

  handleSelectStatementTypeFilter(key){
    this.setState({ selectedStatement: key.value });
    this.props.onSelectStatementTypeFilter(key.value)
  }

  handleSelectPeriodFilter(key){
    this.setState({ selectedPeriod: key.value });
    this.props.onSelectPeriodFilter(key.value)
  }

  setDatePickerValue(value) {
    this.setState({ fromDate: value, toDate: value })
    this.datePickerFromRef && this.datePickerFromRef.setValue(value)
    this.datePickerToRef && this.datePickerToRef.setValue(value)
  }
  setDatePickerValueFM(fromValue,toValue) {
    this.setState({ fromDate: fromValue, toDate: toValue })
    this.datePickerFromRef && this.datePickerFromRef.setValue(fromValue)
    this.datePickerToRef && this.datePickerToRef.setValue(toValue)
  }

  getTransactionHistoryValue() {
    return this.state.selectedTransactionHistoryType
  }

  renderAAStockDisclaimer(){
    const {language} = this.props;
    return(
      <div className='action-item'>
        <div onClick={() => openAAStockDisclaimerDialog()} style={{cursor:'pointer',color:'#1996e3',marginRight:'50px'}}>{getSafe(() => language.aastock_disclaimer_title)}</div>
      </div>
    )
  }

  validateDateRangePicker = (isFromDate, val) => {
    if (isFromDate) {
      this.setState({ minimumDate: val, fromDate: val })
      const { toDate } = this.state;
      if (Object.keys(val).length > 0 && Object.keys(toDate).length > 0) {
        const fDate = new Date(val.year, val.month - 1, val.day);
        const tDate = new Date(toDate.year, toDate.month - 1, toDate.day);
        if (fDate.getTime() > tDate.getTime()) {
          this.datePickerToRef.setValue(val)
          this.props.onChangeDatePicker({ from: val, to: val })
        } else {
          this.props.onChangeDatePicker({ from: val, to: toDate })
        }
      }
    } else {
      this.setState({ toDate: val })
      const { fromDate } = this.state;
      if (Object.keys(val).length > 0 && Object.keys(fromDate).length > 0) {
        this.props.onChangeDatePicker({ from: fromDate, to: val })
      }
    }
  }

  onChangeCurrency = (val,param='from') => {
    const currency = val[0].value;
    this.props.onChangeCurrency(currency, param);
  }

  renderExportExeclButton() {
    const { language, theme } = this.props
    const icons = { 
      dark: ExportIconDark,
      light: ExportIconLight
    }

    const handExportExcelClick = () => {
      const { columnDefs, data, exportExecl = {} } = this.props
      writeFileFunctions.writeExeclFile({ columnDefs, data, ...exportExecl })
    }

    return (
      <BlockControl auth={appConfigConstants.exportExeclFile}>
        <div className='action-item export-file-wrapper'>
          <button className="export-excel-btn" onClick={handExportExcelClick}>
            <img className="export-icon" src={icons[theme]} />
            <span>{language.common_export_execl}</span>
          </button>
        </div>
      </BlockControl>
    )
  }

  renderMarketDropdown() {
    const { currentMarket, language, markets, tabs} = this.props;
    let allMarkets = JSON.parse(JSON.stringify(markets));
    let isMarket = false;
    for (let i = 0; i < tabs.length; i++) {
      if(tabs[i]['title'] === 'watchlist_title'){
        isMarket = true;
        allMarkets.splice(0,1)
        allMarkets.push({
          label: language.market_all,
          value: "ALL"
        })
        break;
      }
    }
    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.common_market}:</label>
          <Dropdown options={isMarket ? allMarkets : markets}
            selectedOptions={isMarket ? [allMarkets[allMarkets.length-1]] : [markets[0]]}
            onChange={(mrk) => this.props.onChangeMarket(mrk[0])}
          />
        </div>
      </div>
    )
  }

  renderAccountDropdown() {
    let { language, accountData } = this.props;
    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.common_setting_account}:</label>
          {
            accountData.length > 0 ? <Dropdown options={accountData}
              selectedOptions={[accountData[0]]}
              onChange={acc => this.props.onChangeAccount(acc[0])}
            />
              :
              <div>{language.common_no_data}</div>
          }
        </div>
      </div>
    )
  }

  renderDateRangePicker() {
    const { language, maximumDate } = this.props;
    const { minimumDate } = this.state;
    return (
      <div className='action-item'>
        <div className="date-picker-filter-container">
          <label>{language.common_filter_enquiry_period}:</label>
          <div className="picker-item">
            <label>{language.common_from}</label>
            <DatePickerCustom
              style={{ height: 23, width: 110, marginTop: -3 }}
              type={DATE_PICKER_TYPE.SINGLE_DATE}
              innerRef={e => this.datePickerFromRef = e}
              onChange={(val) => this.validateDateRangePicker(true, val)}
              maximumDate={maximumDate} />
          </div>
          <div className="picker-item">
            <label>{language.common_to}</label>
            <DatePickerCustom
              style={{ height: 23, width: 110, marginTop: -3 }}
              type={DATE_PICKER_TYPE.SINGLE_DATE}
              innerRef={e => this.datePickerToRef = e}
              onChange={(val) => this.validateDateRangePicker(false, val)}
              minimumDate={minimumDate}
              maximumDate={maximumDate} />
          </div>
        </div>
      </div>
    )
  }

  renderCurrencyDropdown(){
    const currencyOptions = CURRENCY;
    const {language} = this.props;
    return(
      <div className='action-item'>
        <div className='currency-filter-dropdown-container'>
          <label>{language.common_currency}:</label>
          <div className='currency-dropdown-container'>
            <label>{language.common_from}</label>
            <Dropdown options={currencyOptions}
              selectedOptions={[currencyOptions[0]]}
              style={{minWidth:'50px', height:'23px'}}
              innerRef={e => this.fromCurrencyOption = e}
              onChange={(val) => this.onChangeCurrency(val,'from')}
              />
          </div>
          <div className='currency-dropdown-container'>
            <label>{language.common_to}</label>
            <Dropdown options={currencyOptions}
              selectedOptions={[currencyOptions[0]]}
              style={{minWidth:'50px', height:'23px'}}
              innerRef={e => this.toCurrencyOption = e}
              onChange={(val) => this.onChangeCurrency(val,'to')}
              />
          </div>
        </div>
      </div>
    )
  }

  renderOrderFilterDropdown() {
    const { language } = this.props;

    const filterOptions = ORDER_FILTER_STATUS.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    const defaultSelected = filterOptions.filter(item => item.value === this.state.selectedOrderFilterStatus)

    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.common_status}:</label>
          <Dropdown options={filterOptions}
            selectedOptions={defaultSelected}
            onChange={(opt) => this.handleSelectOrderType(opt[0])}
          />
        </div>
      </div>
    )
  }

  renderHistoryFilterDropdown() {
    const { language } = this.props;

    const filterOptions = TRANSACTION_TYPE.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.transaction_type}:</label>
          <Dropdown style={{ minWidth: '210px', height:'23px' }} options={filterOptions}
            selectedOptions={[filterOptions[0]]}
            onChange={(opt) => this.handleSelectTransitionHistoryType(opt[0])}
          />
        </div>
      </div>
    )
  }

  renderOrderFilter() {
    const { language } = this.props;
    const { selectedOrderFilterStatus } = this.state;
    return (
      <div className='action-item'>
        <div className="order-filter-container">
          {ORDER_FILTER_STATUS.map(item =>
            <div key={item.value} className='filter-item' onClick={() => this.handleSelectOrderType(item)}>
              <img src={item.value === selectedOrderFilterStatus ? CheckedIcon : UnCheckIcon} alt="checked_icon" />
              {language[item.label]}
            </div>)}
        </div>
      </div>
    )
  }

  renderAccountTypeFilterDropdown(){
    const { language } = this.props;

    const filterOptions = ACCOUNT_TYPE.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.accountType}:</label>
          <Dropdown style={{ minWidth: '210px', height:'23px' }} options={filterOptions}
            selectedOptions={[filterOptions[0]]}
            onChange={(opt) => this.handleSelectAccountTypeFilter(opt[0])}
          />
        </div>
      </div>
    )
  }

  renderStatementTypeFilterDropdown(){
    const { language } = this.props;

    const filterOptions = STATEMENT_TYPE.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.statementType}:</label>
          <Dropdown style={{ minWidth: '210px', height:'23px' }} options={filterOptions}
            selectedOptions={[filterOptions[0]]}
            onChange={(opt) => this.handleSelectStatementTypeFilter(opt[0])}
          />
        </div>
      </div>
    )
  }

  renderPeriodFilterDropdown(){
    const { language } = this.props;

    const filterOptions = PERIOD.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.period}:</label>
          <Dropdown style={{ minWidth: '210px', height:'23px' }} options={filterOptions}
            selectedOptions={[filterOptions[0]]}
            onChange={(opt) => this.handleSelectPeriodFilter(opt[0])}
          />
        </div>
      </div>
    )
  }

  handleChangeMainTab(mainTab,isback=true) {
    const activeTab = {
      main: mainTab
    }
    this.setState({ currentMainTab: mainTab })
    if (mainTab.children && mainTab.children.length > 0) {
      const activeSubTab = mainTab.children.find(tab => tab.isActive);
      const finalActiveSubTab = activeSubTab ? activeSubTab : mainTab.children[0]
      activeTab.sub = finalActiveSubTab;
      this.setState({ currentSubTab: finalActiveSubTab, subTabs: mainTab.children })
    } else {
      this.setState({ currentSubTab: {}, subTabs: [] })
    }
    this.props.onChangeMainTab(mainTab,isback)
  }

  handleChangeSubTab(subTab) {
    if (subTab.handleClick) {
      subTab.handleClick();
    }else{
      this.props.handleChangeSubTab(subTab , this.state.currentMainTab)
    this.setState({ currentSubTab: subTab })
    }
    
  }

  initData() {
    // Check tabs is valid object format;
    const { tabs } = this.props;
    if (tabs.length > 0) {
      const defaultActiveMainTab = tabs.find(tab => tab.isActive);
      const finalActiveMainTab = defaultActiveMainTab ? defaultActiveMainTab : tabs[0];
      if (finalActiveMainTab.children && finalActiveMainTab.children.length > 0) {
        const defaultActiveSubTab = finalActiveMainTab.children.find(tab => tab.isActive);
        const finalActiveSubTab = defaultActiveSubTab ? defaultActiveSubTab : finalActiveMainTab.children[0];
        this.setState({ subTabs: finalActiveMainTab.children, currentSubTab: finalActiveSubTab })
      }
      this.setState({ mainTabs: tabs, currentMainTab: finalActiveMainTab })
    }
  }

  componentDidMount() {
    document.getElementsByClassName('dialog-content--open')
    this.setState({
      selectedAccount: this.props.currentTradingAccount,
      currencyIDTradingAccounts: this.props.tradingAccounts
    }, () => {
      this.initData();
      this.setState({
        haveActions: this.props.refresh ||
          this.props.orderFilter ||
          this.props.AAStockDisclaimer ||
          this.props.datePicker ||
          this.props.orderFilterDropdown ||
          this.props.transactionHistoryFilter ||
          this.props.marketFilter ||
          this.props.accountDropDown || 
          this.props.accountTypeFilter || 
          this.props.statementTypeFilter || 
          this.props.periodFilter
      })
    })

  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.tabs) !== JSON.stringify(this.props.tabs)) {
      this.initData();
    }
    if (JSON.stringify(prevProps.refresh) !== JSON.stringify(this.props.refresh)) {
      this.setState({
        haveActions: this.props.refresh ||
          this.props.orderFilter ||
          this.props.AAStockDisclaimer ||
          this.props.datePicker ||
          this.props.orderFilterDropdown ||
          this.props.transactionHistoryFilter ||
          this.props.marketFilter ||
          this.props.accountDropDown || 
          this.props.accountTypeFilter || 
          this.props.statementTypeFilter || 
          this.props.periodFilter
      })
    }
  }

  handleContextMenu = (e, tab) => {
    const position = {
      top: e.clientY,
      left: e.clientX,
    }
    if (tab.handleOpenContextMenu) {
      e.preventDefault();
      tab.handleOpenContextMenu(position);
    }
    return false;
  }
}

TabHeader.defaultProps = {
  innerRef: () => { },
  tabs: [],
  onChange: () => { },
  justifyContent: 'flex-start',
  alignItems: 'center',
  enableScroll: false,
  customStyle: null,
  refresh: null,
  onRefresh: () => { },
  orderFilter: null,
  AAStockDisclaimer:null,
  orderFilterDropdown: null,
  onSelectOrderFilter: () => { },
  dateRangePicker: null,
  maximumDate: {},
  onChangeDatePicker: () => { },
  style: {},
  marketFilter: null,
  accountDropDown: null,
  onChangeMarket: () => { },
  onChangeAccount: () => { },
  accountData: [],
  accountTypeFilter : null, 
  statementTypeFilter : null,
  periodFilter : null,
  currencyRangePicker: null
}

export default connect(
  state => ({
    language: state.app.language,
    currentMarket: state.trade.currentMarket,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
    tradingAccounts: state.trade.tradingAccounts,
    currentTradingAccount: state.trade.currentTradingAccount,
    browser:state.app.browser,
    theme:state.app.theme
  }),
  dispatch => ({
  })
)(TabHeader)
